<script setup>
/**
 * BS Modal
 */
import { Modal } from 'bootstrap'
import { onMounted, onUnmounted, ref, shallowRef, watchEffect } from 'vue'
const emit = defineEmits(['hidden'])
const modal = ref(null)
const props = defineProps({
  size: String,
})
let mbs = ref(null)
onMounted(() => {
  mbs.value = new Modal(modal.value)
  modal.value.addEventListener('hidden.bs.modal', onHidden)
  mbs.value.show()
})
onUnmounted(() => {
  if (mbs.value) {
    mbs.value.dispose()
    mbs.value = undefined
  }

  if (modal.value) {
    modal.value.removeEventListener('hidden.bs.modal', onHidden)
  }
})
defineExpose({ hide: () => mbs.value && mbs.value.hide() })
function onHidden() {
  emit('hidden')
}

const clDialog = shallowRef({})
watchEffect(() => {
  if (props.size == 'sm') {
    clDialog.value = { ...clDialog.value, 'modal-sm': true }
  }
})
</script>
<template>
  <Teleport to="body">
    <div class="modal fade" tabindex="-1" ref="modal">
      <div class="modal-dialog" :class="clDialog">
        <div class="modal-content">
          <div class="modal-header">
            <slot name="header" />
            <button type="button" class="btn-close" aria-label="Close" @click="mbs.hide()" />
          </div>
          <div class="modal-body">
            <slot name="default" :mbs="mbs" />
          </div>
          <div class="modal-footer" v-if="$slots.footer">
            <slot name="footer" />
          </div>
        </div>
      </div>
    </div>
  </Teleport>
</template>
